import { motion } from "framer-motion";
import { MapPin, Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "../../lib/site";

export const Location = ({ onBook }) => {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.address)}&output=embed`;

  return (
    <section id="visit" className="relative py-24 md:py-36 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="text-xs uppercase tracking-[0.3em] text-[#C9A24B] mb-6">Visit the Studio</p>
          <h2 className="font-serif-display text-4xl md:text-6xl font-light tracking-tight text-[#FAFAFA] mb-10">
            Find us in <span className="italic gold-gradient-text">Calgary</span>
          </h2>

          <div className="space-y-6">
            <a href={`https://maps.google.com/?q=${encodeURIComponent(BUSINESS.address)}`} target="_blank" rel="noreferrer"
               className="flex items-start gap-4 group" data-testid="location-address">
              <span className="mt-1 w-10 h-10 shrink-0 rounded-sm border border-[#C9A24B]/40 flex items-center justify-center text-[#C9A24B]"><MapPin size={18} /></span>
              <span className="text-[#FAFAFA] group-hover:text-[#C9A24B] transition-colors">{BUSINESS.address}</span>
            </a>
            <a href={`tel:${BUSINESS.phone.replace(/[^\d+]/g, "")}`} className="flex items-center gap-4 group" data-testid="location-phone">
              <span className="w-10 h-10 shrink-0 rounded-sm border border-[#C9A24B]/40 flex items-center justify-center text-[#C9A24B]"><Phone size={18} /></span>
              <span className="text-[#FAFAFA] group-hover:text-[#C9A24B] transition-colors">{BUSINESS.phone}</span>
            </a>
            <a href={`https://wa.me/${BUSINESS.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 group" data-testid="location-whatsapp">
              <span className="w-10 h-10 shrink-0 rounded-sm border border-[#C9A24B]/40 flex items-center justify-center text-[#C9A24B]"><MessageCircle size={18} /></span>
              <span className="text-[#FAFAFA] group-hover:text-[#C9A24B] transition-colors">Chat on WhatsApp</span>
            </a>
          </div>

          <button
            onClick={onBook}
            data-testid="visit-book-btn"
            className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-[#C9A24B] text-black text-xs uppercase tracking-[0.2em] font-semibold rounded-sm hover:scale-105 hover:bg-[#d9b463] transition-transform transition-colors duration-300"
          >
            Reserve Your Chair →
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-sm overflow-hidden border border-[#C9A24B]/30 h-[380px] md:h-[460px]"
        >
          <iframe title="El Japonais location" src={mapSrc} className="w-full h-full grayscale contrast-125" style={{ border: 0 }} loading="lazy" />
        </motion.div>
      </div>

      <footer className="max-w-[1400px] mx-auto px-6 md:px-10 mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={BUSINESS.logo} alt="El Japonais" className="h-9 w-9 rounded-full object-cover ring-1 ring-[#C9A24B]/50" />
          <span className="font-serif-display text-lg gold-gradient-text">El Japonais</span>
        </div>
        <p className="text-xs text-[#8A8A8A] tracking-wide">© 2026 El Japonais · {BUSINESS.tagline}</p>
      </footer>
    </section>
  );
};
